export default __webpack_public_path__ + "src/assets/img_frame_427319473.2293e91796b1a5e3d91ec46d2b76be74.webp";